import { Alert, Icon } from '@ps/isp-web-component-library';
import { Cash } from '@ps/isp-web-component-library/icons/Cash';
import { ChevronMediumDown } from '@ps/isp-web-component-library/icons/ChevronMediumDown';
import { FreeBetSb } from '@ps/isp-web-component-library/icons/FreeBetSb';
import { Gift } from '@ps/isp-web-component-library/icons/Gift';
import { useTrackers } from '@ps/web-shared-analytics';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import type { StarsWebExtraWallet } from '@swf/core/models/sports/extraWallets/types';
import {
  getIsWalletBonusCash,
  getIsWalletFreeBet
} from '@swf/core/models/sports/extraWallets/utils/getIsWallet';
import { select } from '@swf/core/store';
import useBonusAction from '@swf/sports/hooks/useBonusAction';

import WalletDetailTitle from '../ExtraWalletsTitle/WalletDetailTitle/WalletDetailTitle';

import {
  TXTWCL_Read_the_full_Terms_and_Condit_ELL,
  TXTWCL_To_use_the_rewardX_create_an_e_ELL,
  TXTWCL_To_use_the_rewardX_create_an_e_ELL_1
} from './WalletDetail.messages.json';
import styles from './WalletDetail.scss';

interface Props {
  wallet: StarsWebExtraWallet;
  hasVisibleDetails: boolean;
  toggleDetails(e: React.MouseEvent<HTMLElement>, id: StarsWebExtraWallet['id']): void;
}

const WalletDetail: React.FC<Props> = ({ wallet, hasVisibleDetails, toggleDetails }) => {
  const { buttonPressed } = useTrackers();
  const freeBetWallets = useSelector(select.extraWallets.getFreeBetsWallets);
  const bonusCashWallets = useSelector(select.extraWallets.getBonusCashWallets);
  const showTwoPromotionIcons = !!(freeBetWallets.length && bonusCashWallets.length);

  const isBonusCash = getIsWalletBonusCash(wallet);
  const isFreeBet = getIsWalletFreeBet(wallet);
  const { action } = useBonusAction(isBonusCash);

  const handleTermsAndConditionsClick = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    buttonPressed({ buttonName: 'Offer Info' });

    action();
  };

  const promotionIcon = () => {
    if (isFreeBet) {
      return (
        <Icon icon={FreeBetSb} size="x1" className={styles.bonusIcon} data-testid="sports-icon" />
      );
    } else if (isBonusCash) {
      return <Icon icon={Cash} size="x1" className={styles.bonusIcon} data-testid="sports-icon" />;
    }
  };

  return (
    <details open={hasVisibleDetails}>
      <summary onClick={(e) => toggleDetails(e, wallet.id)} data-testid="bonus-details">
        <WalletDetailTitle wallet={wallet} hasVisibleDetails={hasVisibleDetails} />
      </summary>
      <div className={styles.detailsBody}>
        <Alert level="promotion">
          <p className={styles.detailsMessage}>
            {showTwoPromotionIcons ? (
              <Translation
                values={{
                  0: promotionIcon(),
                  1: (
                    <Icon
                      icon={Gift}
                      size="x1"
                      className={styles.bonusIcon}
                      data-testid="sports-icon"
                    />
                  )
                }}
                {...TXTWCL_To_use_the_rewardX_create_an_e_ELL_1}
              />
            ) : (
              <Translation
                values={{ 0: promotionIcon() }}
                {...TXTWCL_To_use_the_rewardX_create_an_e_ELL}
              />
            )}
          </p>
        </Alert>
      </div>
      <div onClick={handleTermsAndConditionsClick} className={styles.termsAndConditions}>
        <Translation {...TXTWCL_Read_the_full_Terms_and_Condit_ELL} />
        <Icon icon={ChevronMediumDown} size="x1" className={styles.termsAndConditionsIcon} />
      </div>
    </details>
  );
};

export default WalletDetail;
